// cart page block

if (location.pathname === '/cart' && !location.search) {
	window.location.href = '/?return_link=cart';
}

// Open cart drawer when redirected with ?return_link=cart
if (new URLSearchParams(location.search).has('return_link')) {
	const cartDrawerObserver = new MutationObserver(() => {
		let cartDrawer = document.querySelector('cart-drawer');
		if (cartDrawer) {
			cartDrawer.show();
			cartDrawerObserver.disconnect(); // Stop observing after cart opens
		}
	});
	cartDrawerObserver.observe(document.body, { childList: true, subtree: true });

	// Remove return_link=cart from the URL
	const newUrl = location.href.replace(/[?&]return_link=cart/g, '');
	history.replaceState({}, document.title, newUrl);
}

// Handle browser back button to close cart
window.addEventListener('popstate', function (event) {
	const cartDrawer = document.querySelector('cart-drawer');
	if (cartDrawer && !location.search.includes('cartOpen=true')) {
		cartDrawer.close();
	} else if (event.state?.cart === 'show' && cartDrawer) {
		cartDrawer.show();
	}
});

// Ensure cartOpen=true is removed from URL if cart is closed
document.addEventListener('DOMContentLoaded', () => {
	const cartDrawer = document.querySelector('cart-drawer');
	if (cartDrawer && !cartDrawer.classList.contains('active')) {
		const newUrl = location.href.replace(/[?&]cartOpen=true/g, '');
		history.replaceState({}, document.title, newUrl);
	}
});

// Open cart and push cartOpen=true into history
function openCart() {
	const cartDrawer = document.querySelector('cart-drawer');
	if (cartDrawer) {
		cartDrawer.show();
		history.pushState({ cart: 'show' }, '', '?cartOpen=true');
	}
}

// judgeme js
const ratingProductCard = document.querySelector('.rating-pdp-card');
const judgemeProductReviews = document.getElementById('judgeme_product_reviews');
ratingProductCard?.addEventListener('click', function () {
	judgemeProductReviews.scrollIntoView({ behavior: 'smooth' });
});

class RoundRating extends HTMLElement {
	constructor() {
		super();
		this.#init();
	}

	#init() {
		const value = parseFloat(this.textContent.trim());
		const roundedValue = Math.round(value * 10) / 10;
		this.textContent = roundedValue.toFixed(1);
	}
}

customElements.define('round-rating', RoundRating);

// cart-change-handler.js
document.addEventListener('cart:change', async (event) => {
	const cartData = event.detail.cart;
	const baseEvent = event.detail.baseEvent;

	console.log('Base Event:', baseEvent);  

	// First handle the case of removing add-ons when main product is gone
	const mainProducts = cartData.items.filter(item => !item.properties?._main_product);
	const addOns = cartData.items.filter(item => item.properties?._main_product);
	
	// If there are add-ons but no main products, remove ALL add-ons
	if (addOns.length > 0 && mainProducts.length === 0) {
		console.log("No main products exist but add-ons found. Removing all add-ons.");
		await forceRemoveAllAddons(addOns);
		return; // Exit early after handling this case
	}
	
	// Check if any add-ons have a main product that no longer exists
	if (addOns.length > 0 && mainProducts.length > 0) {
		const orphanedAddons = addOns.filter(addon => {
			// Find if this addon's main product still exists
			const mainProductExists = mainProducts.some(main => 
				main.handle === addon.properties._main_product
			);
			return !mainProductExists;
		});
		
		if (orphanedAddons.length > 0) {
			console.log("Found orphaned add-ons to remove:", orphanedAddons);
			await forceRemoveAllAddons(orphanedAddons);
			return; // Exit early after handling this case
		}
	}
	
	// Handle changes to the main product quantity
	if (baseEvent === 'line-item:change' || baseEvent === 'variant:add' || baseEvent === 'item:remove') {
		// For each main product
		for (const mainProduct of mainProducts) {
			// Find add-ons for this specific main product
			const relatedAddons = addOns.filter(addon => 
				addon.properties._main_product === mainProduct.handle
			);
			
			if (relatedAddons.length === 0) continue;
			
			// If main product quantity is 0, remove all its add-ons
			if (mainProduct.quantity === 0) {
				console.log(`Main product ${mainProduct.handle} has 0 quantity. Removing all its add-ons.`);
				await forceRemoveAllAddons(relatedAddons);
				continue;
			}
			
			// For ready-to-wear and gift wrap items, sync quantities
			const syncableAddons = relatedAddons.filter(addon => {
				const isReadyToWear = 
					(addon.product_title && addon.product_title.toLowerCase().includes('ready-to-wear')) ||
					(addon.product_title && addon.product_title.toLowerCase().includes('pre-drape')) ||
					(addon.variant_title && addon.variant_title.toLowerCase().includes('ready-to-wear'));
					
				const isGiftWrap = 
					(addon.handle === 'gift-wrapping') || 
					(addon.product_title && addon.product_title.toLowerCase().includes('gift wrap') && 
					!addon.product_title.toLowerCase().includes('gift box'));
					
				return isReadyToWear || isGiftWrap;
			});
			
			if (syncableAddons.length > 0) {
				// Check if any addon needs its quantity updated
				const needsSync = syncableAddons.some(addon => addon.quantity !== mainProduct.quantity);
				
				if (needsSync) {
					console.log(`Syncing ${syncableAddons.length} add-ons for main product ${mainProduct.handle}`);
					await syncAddonQuantities(syncableAddons, mainProduct.quantity);
				}
			}
		}
	}
	
	// Check for gift-wrapping items
	checkAndRemoveGiftWrappingItems(cartData);
});

// Helper function to force remove all add-ons (sets quantity to 0)
async function forceRemoveAllAddons(addons) {
	if (!addons || addons.length === 0) return;
	
	document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));
	
	try {
		let sectionsToBundle = [];
		document.documentElement.dispatchEvent(
			new CustomEvent('cart:prepare-bundled-sections', {
				bubbles: true,
				detail: { sections: sectionsToBundle },
			}),
		);
		
		// Build updates object with all quantities set to 0
		const updates = {};
		addons.forEach(addon => {
			updates[addon.key] = 0;
		});
		
		console.log("Removing add-ons with updates:", updates);
		
		const response = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'X-Requested-With': 'XMLHttpRequest',
			},
			body: JSON.stringify({
				updates,
				sections: sectionsToBundle.join(','),
				sections_url: window.location.pathname,
			}),
		});
		
		if (!response.ok) throw new Error('Failed to update cart');
		
		const updatedCartContent = await response.json();
		console.log("Cart updated after removing add-ons:", updatedCartContent);
		
		// Dispatch cart change event to update the UI
		document.documentElement.dispatchEvent(
			new CustomEvent('cart:refresh', {
				bubbles: true,
			}),
		);
		
		document.documentElement.dispatchEvent(
			new CustomEvent('cart:change', {
				bubbles: true,
				detail: {
					baseEvent: 'item:remove',
					cart: updatedCartContent,
				},
			}),
		);
		
		// Update cart UI
		const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
		if (cart && typeof cart.renderContents === 'function') {
			cart.renderContents(updatedCartContent);
		}
	} catch (error) {
		console.error('Error removing add-ons:', error);
	} finally {
		document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
	}
}

// Helper function to sync addon quantities
async function syncAddonQuantities(addons, newQuantity) {
	if (!addons || addons.length === 0) return;
	
	document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));
	
	try {
		let sectionsToBundle = [];
		document.documentElement.dispatchEvent(
			new CustomEvent('cart:prepare-bundled-sections', {
				bubbles: true,
				detail: { sections: sectionsToBundle },
			}),
		);
		
		// Update all addons to the new quantity
		const updates = {};
		addons.forEach(addon => {
			updates[addon.key] = newQuantity;
		});
		
		console.log("Syncing addons with updates:", updates);
		
		const response = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'X-Requested-With': 'XMLHttpRequest',
			},
			body: JSON.stringify({
				updates,
				sections: sectionsToBundle.join(','),
				sections_url: window.location.pathname,
			}),
		});
		
		if (!response.ok) throw new Error('Failed to update cart');
		
		const updatedCartContent = await response.json();
		console.log("Cart updated after syncing addons:", updatedCartContent);
		
		// Rebuild cart UI
		document.documentElement.dispatchEvent(
			new CustomEvent('cart:change', {
				bubbles: true,
				detail: {
					baseEvent: 'item:update',
					cart: updatedCartContent,
				},
			}),
		);
		
		// Force update cart UI
		const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
		if (cart && typeof cart.renderContents === 'function') {
			cart.renderContents(updatedCartContent);
		}
	} catch (error) {
		console.error('Error syncing addon quantities:', error);
	} finally {
		document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
	}
}

window.initializeVideoControls = function() {
	const video = document.querySelector('.video-element');
	if (!video) return;

	const muteToggle = document.getElementById('mute-toggle');
	if (!muteToggle) return;

	const unmuteText = muteToggle.querySelector('.unmute-text');
	const muteText = muteToggle.querySelector('.mute-text');

	// Toggle mute/unmute when the button is clicked
	muteToggle.addEventListener('click', function () {
		video.muted = !video.muted;

		// Toggle button text
		if (video.muted) {
			unmuteText.style.display = 'inline';
			muteText.style.display = 'none';
		} else {
			unmuteText.style.display = 'none';
			muteText.style.display = 'inline';
		}
	});

	// Toggle play/pause on video click
	video.addEventListener('click', function () {
		this.paused ? this.play() : this.pause();
	});
};

// Initialize video controls if video element exists
if (document.querySelector('.video-element')) {
	window.initializeVideoControls();
}

// Size Chart Toggle in inches and cms
if (document.querySelector('.toggle-tab-inches-cm')) {
	window.handleSizeToggle();
}  

// typewriter component
class TypewriterComponent extends HTMLElement {
	constructor() {
		super();
		this.texts = Array.from(this.querySelectorAll('p')).map((message) => message.innerHTML);
		this.currentTextIndex = 0;
		this.currentCharIndex = 0;
		this.isDeleting = false;
		this.typeSpeed = 100; // Adjust typing speed (in milliseconds)
		this.deleteSpeed = 50; // Adjust deleting speed (in milliseconds)
		this.pauseBetweenTexts = 2000; // Pause between texts (in milliseconds)
		this.type();
	}

	type() {
		const currentText = this.texts[this.currentTextIndex];
		const displayText = this.isDeleting ? currentText.substring(0, this.currentCharIndex - 1) : currentText.substring(0, this.currentCharIndex + 1);

		this.innerHTML = displayText;

		if (!this.isDeleting) {
			this.currentCharIndex++;
			if (this.currentCharIndex === currentText.length) {
				this.isDeleting = true;
				setTimeout(() => this.type(), this.pauseBetweenTexts);
			} else {
				setTimeout(() => this.type(), this.typeSpeed);
			}
		} else {
			this.currentCharIndex--;
			if (this.currentCharIndex === 0) {
				this.isDeleting = false;
				this.currentTextIndex = (this.currentTextIndex + 1) % this.texts.length;
				setTimeout(() => this.type(), this.typeSpeed);
			} else {
				setTimeout(() => this.type(), this.deleteSpeed);
			}
		}
	}
}

customElements.define('typewriter-component', TypewriterComponent);

// Read more collection description
function setupReadMore() {
	// Select the container
	const container = document.querySelector('.collection-description');
	if (!container) return;

	// Get all text content excluding h1
	let fullText = '';
	const childNodes = Array.from(container.childNodes);
	childNodes.forEach((node) => {
		if (node.nodeName !== 'H1') {
			fullText += node.textContent.trim() + ' ';
		}
	});

	// Clean up text and split into words
	fullText = fullText.trim();
	const words = fullText.split(/\s+/);

	// Create shortened version (25 words)
	const shortText = words.slice(0, 20).join(' ');

	// Create custom read-more element
	const readMoreEl = document.createElement('read-more');

	// Initial HTML structure
	if (fullText != '') {
		readMoreEl.innerHTML = `
		<span class="short-text">${shortText}...</span>
		<span class="full-text" style="display: none;">${fullText}</span>
		<button class="read-more-btn read-more-state">Read More</button>
	`;
	}

	// Clear container content except h1
	const h1 = container.querySelector('h1');
	container.innerHTML = '';
	if (h1) container.appendChild(h1);

	// Add read-more element
	if (fullText != '') {
		container.appendChild(readMoreEl);
	}

	// Add click event listener
	const btn = readMoreEl.querySelector('.read-more-btn');
	const shortTextSpan = readMoreEl.querySelector('.short-text');
	const fullTextSpan = readMoreEl.querySelector('.full-text');

	btn.addEventListener('click', () => {
		const isExpanded = shortTextSpan.style.display === 'none';
		container.style.maxHeight = 'max-content';
		shortTextSpan.style.display = isExpanded ? 'inline' : 'none';
		fullTextSpan.style.display = isExpanded ? 'none' : 'inline';
		btn.textContent = isExpanded ? 'Read More' : 'Read Less';

		// Toggle button color class
		btn.classList.toggle('read-more-state');
		btn.classList.toggle('read-less-state');
	});
}
if (document.querySelector('.collection-description')) {
	document.addEventListener('DOMContentLoaded', setupReadMore);
}

class ProductSwatch extends HTMLElement {
	constructor() {
		super();
		this.addEventListener('click', this.handleSwatchClick.bind(this));
	}

	// Handle swatch click event
	async handleSwatchClick(event) {
		event.preventDefault();

		// Get the product URL and handle from the data attributes
		const productUrl = this.dataset.productUrl;
		const productHandle = this.dataset.productHandle;

		if (!productUrl || !productHandle) return;

		// Show loading state
		this.setLoadingState(true);

		try {
			// Fetch the entire product page instead of just the section
			const response = await fetch(productUrl);
			const html = await response.text();
			
			// Parse the HTML content
			const parser = new DOMParser();
			const doc = parser.parseFromString(html, 'text/html');
			
			// Find the product section to update
			const productSection = document.getElementById(this.getAttribute('data-section-id'));
			
			if (productSection) {
				// Get the corresponding section from the fetched HTML
				const newProductSection = doc.getElementById(this.getAttribute('data-section-id'));
				
				if (newProductSection) {
					// Replace the entire section content
					productSection.innerHTML = newProductSection.innerHTML;
					
					// Handle scripts more carefully to avoid redeclaration errors
					const scriptElements = productSection.querySelectorAll('script');
					scriptElements.forEach(oldScript => {
						// Skip scripts that might cause redeclaration errors
						if (oldScript.textContent.includes('class') || 
							oldScript.textContent.includes('function') || 
							oldScript.textContent.includes('const ') || 
							oldScript.textContent.includes('let ') || 
							oldScript.textContent.includes('var ')) {
						
							// For scripts that define classes/functions, we'll evaluate them in a safer way
							try {
								// Create a new function from the script content and execute it
								// This avoids redeclaration errors in the global scope
								const scriptContent = oldScript.textContent;
								const scriptFunc = new Function(scriptContent);
								scriptFunc();
							} catch (scriptError) {
								console.warn('Script execution error:', scriptError);
							}
						} else {
							// For other scripts (like inline event handlers), replace them normally
							const newScript = document.createElement('script');
							Array.from(oldScript.attributes).forEach(attr => {
								newScript.setAttribute(attr.name, attr.value);
							});
							newScript.appendChild(document.createTextNode(oldScript.innerHTML));
							oldScript.parentNode.replaceChild(newScript, oldScript);
						}
					});
					
					// Dispatch events to notify other components
					document.dispatchEvent(new CustomEvent('shopify:section:load', {
						detail: { section: productSection }
					}));
					
					document.dispatchEvent(new CustomEvent('product:loaded', {
						bubbles: true,
						detail: { productElement: productSection }
					}));
				}
			}

			// Update the URL in the browser without reloading the page
			history.replaceState(null, '', productUrl);
		} catch (error) {
			console.error('Error fetching product:', error);
		} finally {
			// Hide loading state
			this.setLoadingState(false);
			this.scrollToTop();
		}
	}
  
	scrollToTop() {
		window.scrollTo({
			top: 150,
			behavior: 'smooth',
		});
	}

	// Set loading state for the carousel
	setLoadingState(isLoading) {
		const carousel = this.closest('custom-carousel');
		if (carousel) {
			carousel.classList.toggle('loading', isLoading);
		}
	}
}

// Define the custom element
customElements.define('product-swatch', ProductSwatch);

class ProductAddonCart extends HTMLElement {
	constructor() {
		super();
		this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
		this.productHandle = this.dataset.productHandle;
		this.addEventListener('click', this.handleClick.bind(this));
		this.selectedVariantId = this.dataset.productSelectedVariant;
		
		// Set default values for selects if not already set
		this.setDefaultValues();
		
		this.setupEventListeners();
	}

	setDefaultValues() {
		// Set default values for all selects if they don't have a value
		this.querySelectorAll('select').forEach(select => {
			if (!select.value && select.options.length > 0) {
				// First check if there's a selected option in HTML
				const selectedOption = select.querySelector('option[selected]');
				if (selectedOption) {
					select.value = selectedOption.value;
				} else {
					// Otherwise select first option
					select.selectedIndex = 0;
				}
			}
		});
	}

	setupEventListeners() {
		// Pre-drape fields toggle
		const preDrapeCheckbox = this.querySelector('.pre-drape-checkbox');
		const preDrapeFields = this.querySelector('.pre-drape-fields');
		const preDrapeMessageContainer = this.querySelector('.pre-drape-message-container');
		
		if (preDrapeCheckbox && preDrapeFields) {
			preDrapeCheckbox.addEventListener('change', () => {
				preDrapeFields.classList.toggle('hidden', !preDrapeCheckbox.checked);
				preDrapeMessageContainer.classList.toggle('hidden', !preDrapeCheckbox.checked);
				this.toggleAddToCartButton();
			});
		}

		// Gift options toggle
		const giftSelectionCheckbox = this.querySelector('.gift-selection-checkbox');
		const giftOptionsContainer = this.querySelector('.gift-options');
		const giftMessageContainer = this.querySelector('.gift-message-container');

		if (giftSelectionCheckbox && giftOptionsContainer) {
			giftSelectionCheckbox.addEventListener('change', () => {
				giftOptionsContainer.classList.toggle('hidden', !giftSelectionCheckbox.checked);

				// Uncheck all individual gift option checkboxes if main checkbox is unchecked
				if (!giftSelectionCheckbox.checked) {
					this.querySelectorAll('.gift-option-checkbox').forEach((checkbox) => {
						checkbox.checked = false;
					});
					giftMessageContainer.classList.add('hidden');
				}

				this.toggleAddToCartButton();
			});
		}

		// Individual gift option checkboxes
		this.querySelectorAll('.gift-option-checkbox').forEach((checkbox) => {
			checkbox.addEventListener('change', () => {
				const anyGiftOptionChecked = Array.from(this.querySelectorAll('.gift-option-checkbox')).some(
					(checkbox) => checkbox.checked
				);
				giftMessageContainer.classList.toggle('hidden', !anyGiftOptionChecked);
				this.toggleAddToCartButton();
			});
		});

		// Main matching addon toggle
		const matchingAddonCheckbox = this.querySelector('.matching-addon-checkbox');
		const addonOptionsContainer = this.querySelector('.addon-options');

		if (matchingAddonCheckbox && addonOptionsContainer) {
			matchingAddonCheckbox.addEventListener('change', () => {
				addonOptionsContainer.classList.toggle('hidden', !matchingAddonCheckbox.checked);

				// Uncheck all individual addon checkboxes if main checkbox is unchecked
				if (!matchingAddonCheckbox.checked) {
					this.querySelectorAll('.addon-checkbox').forEach((checkbox) => {
						checkbox.checked = false;
						this.toggleAddonFields(checkbox);
					});
				}

				this.toggleAddToCartButton();
			});
		}

		// Individual addon checkboxes
		this.querySelectorAll('.addon-checkbox').forEach((checkbox) => {
			checkbox.addEventListener('change', () => {
				this.toggleAddonFields(checkbox);
				this.toggleAddToCartButton();
			});
		});

	}

	toggleAddonFields(checkbox) {
		const addonOption = checkbox.closest('.addon-option');
		const addonFields = addonOption.querySelector('.addon-fields');

		if (addonFields) {
			addonFields.classList.toggle('hidden', !checkbox.checked);
		}
	}

	toggleAddToCartButton() {
		const isAnyCheckboxChecked =
			this.querySelector('.pre-drape-checkbox:checked') ||
			this.querySelector('.addon-checkbox:checked') ||
			this.querySelector('.gift-option-checkbox:checked');

		const button = this.querySelector('product-addon-cart .button');
		const mainATC = document.querySelector('.product .product-info__block-item:is([data-block-type=buy-buttons])');
		const mainContainer = document.querySelector('product-addon-cart .addon-container');

		if (button) {
			button.classList.toggle('hidden', !isAnyCheckboxChecked);
			mainContainer.classList.toggle('on-checked-container', isAnyCheckboxChecked);
			mainATC.classList.toggle('hidden', isAnyCheckboxChecked);
		}
	}

	validateFields() {
		let isValid = true;
		const errors = [];

		const preDrapeCheckbox = this.querySelector('.pre-drape-checkbox');
		if (preDrapeCheckbox?.checked) {
			const sizeSelect = this.querySelector('.pre-drape-size');
			if (!sizeSelect.value || sizeSelect.value === '') {
				errors.push('Invalid size selection');
				isValid = false;
			}
		}

		if (!isValid) {
			alert(errors.join('\n'));
		}

		return isValid;
	}

	resetForm() {
		// Uncheck all checkboxes
		this.querySelectorAll('input[type="checkbox"]').forEach((checkbox) => {
			checkbox.checked = false;
		});

		// Reset all select elements to their first options
		this.querySelectorAll('select').forEach((select) => {
			if (select.options.length > 0) {
				// If the select has a selected option (from HTML), maintain that selection
				const selectedOption = select.querySelector('option[selected]');
				if (selectedOption) {
					select.value = selectedOption.value;
				} else {
					// Otherwise select the first option
					select.selectedIndex = 0;
				}
			}
		});

		// Clear all input fields that are not selects
		this.querySelectorAll('input[type="number"], input[type="text"]').forEach((input) => {
			input.value = '';
		});

		// Hide all addon fields
		this.querySelectorAll('.addon-fields, .pre-drape-fields, .gift-message-container').forEach((field) => {
			field.classList.add('hidden');
		});

		// Hide addon options
		const addonOptionsContainer = this.querySelector('.addon-options');
		if (addonOptionsContainer) {
			addonOptionsContainer.classList.add('hidden');
		}

		// Hide gift options
		const giftOptionsContainer = this.querySelector('.gift-options');
		if (giftOptionsContainer) {
			giftOptionsContainer.classList.add('hidden');
		}

		// Toggle the add-to-cart button
		this.toggleAddToCartButton();
	}

	async handleClick(event) {
		if (!event.target.matches('button')) return;

		event.preventDefault();

		if (!this.validateFields()) return;

		// Add loading spinner to body
		document.body.classList.add('loading-spinner');
		
		document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));
		
		try {
			await this.addProductsToCart();
		} catch (error) {
			console.error('Error adding products to cart:', error);
			alert(error.message || 'An error occurred while adding products to cart');
		} finally {
			document.body.classList.remove('loading-spinner');
			this.resetForm();
			document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
		}
	}

	async addProductsToCart() {
		const mainProductTitle = this.productHandle;
		const mainProductQuantity = document.querySelector('input[name="quantity"]')?.value || 1;

		const items = [];

		// Add main product using stored variant ID
		items.push({
			id: this.selectedVariantId,
			quantity: parseInt(mainProductQuantity),
			properties: {}, // Will be populated based on selected addons
		});

		// Add pre-drape if selected
		const preDrapeSection = this.querySelector('.pre-drape-section');
		if (preDrapeSection && this.querySelector('.pre-drape-checkbox').checked) {
			const sizeSelect = this.querySelector('.pre-drape-size');
			const preDrapeMessage = this.querySelector('.pre-drape-message-input').value.trim();
			
			// Get the variant ID for the selected size
			const selectedSize = sizeSelect.value;
			
			items.push({
				id: preDrapeSection.dataset.variantId,
				quantity: 1,
				properties: {
					_main_product: mainProductTitle,
					...(preDrapeMessage ? { instructions: preDrapeMessage } : {}),
				},
			});
			items[0].properties._has_pre_drape = 'Yes';
		}

		// Add addons if selected
		this.querySelectorAll('.addon-option').forEach((addonOption) => {
			const addonCheckbox = addonOption.querySelector('.addon-checkbox');
			if (addonCheckbox.checked) {
				const addonIndex = addonOption.dataset.addonIndex;
				const addonTitle = addonOption.dataset.productTitle;

				// Check if addon has size selection
				const sizeSelect = addonOption.querySelector('.addon-size');
				const selectedVariantId = sizeSelect ? sizeSelect.value : addonOption.dataset.variants.split(',')[0];

				items.push({
					id: selectedVariantId,
					quantity: 1,
				});

				// Add property to main item to indicate addon
				items[0].properties._has_addon = 'Yes';
			}
		});

		// Add gift options if selected
		this.querySelectorAll('.gift-option').forEach((giftOption) => {
			const giftCheckbox = giftOption.querySelector('.gift-option-checkbox');
			if (giftCheckbox.checked) {
				const giftVariantId = giftOption.dataset.variantId;
				items.push({
					id: giftVariantId,
					quantity: 1,
					properties: {
						_main_product: mainProductTitle,
					},
				});

				// Add property to main item to indicate gift
				items[0].properties._has_gift = 'Yes';
			}
		});

		// Add gift message if any gift option is selected
		const giftMessageInput = this.querySelector('.gift-message-input');
		if (giftMessageInput && giftMessageInput.value.trim() !== '') {
			items[0].properties.gift_message = giftMessageInput.value.trim();
		}

		// Prepare sections for cart update
		let sectionsToBundle = [];
		document.documentElement.dispatchEvent(
			new CustomEvent('cart:prepare-bundled-sections', {
				bubbles: true,
				detail: { sections: sectionsToBundle },
			})
		);

		const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'X-Requested-With': 'XMLHttpRequest',
			},
			body: JSON.stringify({
				items: items,
				sections: sectionsToBundle.join(','),
				sections_url: window.location.pathname,
			}),
		});

		const responseJson = await response.json();

		if (response.ok) {
			if (window.themeVariables.settings.cartType === 'page') {
				window.location.href = `${window.Shopify.routes.root}cart`;
				return;
			}

			const cartContent = await (await fetch(`${window.Shopify.routes.root}cart.js`)).json();
			cartContent.sections = responseJson.sections;

			// Dispatch cart events
			this.dispatchEvent(
				new CustomEvent('variant:add', {
					bubbles: true,
					detail: {
						items: responseJson.items || [responseJson],
						cart: cartContent,
					},
				})
			);

			document.documentElement.dispatchEvent(
				new CustomEvent('cart:change', {
					bubbles: true,
					detail: {
						baseEvent: 'variant:add',
						cart: cartContent,
					},
				})
			);
		} else {
			throw new Error(responseJson.description);
		}
	}
}

if (!window.customElements.get('product-addon-cart')) {
	window.customElements.define('product-addon-cart', ProductAddonCart);
}

// Add this function to check and remove gift-wrapping items when they're alone in cart
function checkAndRemoveGiftWrappingItems(cartData) {
	// Check if cart has items
	if (!cartData || !cartData.items || cartData.items.length === 0) return;
	
	// If there's only gift-wrapping items in the cart, remove them
	const giftWrappingItems = cartData.items.filter(item => 
		item.handle === 'gift-wrapping' || 
		item.product_title.toLowerCase().includes('gift wrap')
	);
	
	// If all items are gift-wrapping items, remove them
	if (giftWrappingItems.length > 0 && giftWrappingItems.length === cartData.items.length) {
		document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));
		
		try {
			let sectionsToBundle = [];
			document.documentElement.dispatchEvent(
				new CustomEvent('cart:prepare-bundled-sections', {
					bubbles: true,
					detail: { sections: sectionsToBundle },
				}),
			);
			
			// Prepare updates to set gift-wrapping quantities to 0
			const updates = giftWrappingItems.reduce((acc, item) => {
				acc[item.key] = 0;
				return acc;
			}, {});
			
			// Update cart to remove gift-wrapping items
			fetch(`${window.Shopify.routes.root}cart/update.js`, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					'X-Requested-With': 'XMLHttpRequest',
				},
				body: JSON.stringify({
					updates,
					sections: sectionsToBundle.join(','),
					sections_url: window.location.pathname,
				}),
			})
			.then(response => {
				if (!response.ok) throw new Error('Failed to update cart');
				return response.json();
			})
			.then(updatedCartContent => {
				// Dispatch cart change event to update the UI
				document.documentElement.dispatchEvent(
					new CustomEvent('cart:change', {
						bubbles: true,
						detail: {
							baseEvent: 'item:remove',
							cart: updatedCartContent,
						},
					}),
				);
				
				// Update cart UI
				const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
			})
			.catch(error => {
				console.error('Error removing gift-wrapping items:', error);
				if (window.themeVariables?.settings.showErrorMessage) {
					alert(error.message);
				}
			})
			.finally(() => {
				document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
			});
		} catch (error) {
			console.error('Error checking gift-wrapping items:', error);
			document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
		}
	}
}

// section scroller
class SectionScroller extends HTMLElement {
	constructor() {
		super();
		this.isAtTop = true;
		this.topThreshold = 80; // Set threshold to 80px
		this.addEventListener('click', this.handleClick);
		window.addEventListener('scroll', this.handleScroll.bind(this));
		this.handleScroll(); // Initialize state on load
		this.updateArrowDirection();
		// Add double tap tracking
		this.lastTapTime = 0;
		this.doubleTapDelay = 300; // 300ms between taps to count as double-tap
	}

	handleClick() {
		const currentTime = new Date().getTime();
		const tapLength = currentTime - this.lastTapTime;
		
		// Check for double tap
		if (!this.isAtTop && tapLength < this.doubleTapDelay && tapLength > 0) {
			// Double tap detected - scroll to viewport top
			window.scrollTo({
				top: 0,
				behavior: 'smooth'
			});
			this.isAtTop = true;
			this.updateArrowDirection();
			
			// Reset tap tracking
			this.lastTapTime = 0;
			return;
		}
		
		// Save the tap time for potential double tap detection
		this.lastTapTime = currentTime;
		
		// Normal single tap behavior
		if (this.isAtTop) {
			// If at top, scroll to featured categories section
			const featuredSection = document.querySelector('.featured-categories-max-width, .product-discount-carousel') || document.querySelector('.shopify-section--related-products');
			if (featuredSection) {
				featuredSection.scrollIntoView({ 
					behavior: 'smooth',
					block: 'start'
				});
				this.isAtTop = false;
				this.updateArrowDirection();
			}
		} else {
			// Check if we're below the apps section
			const appsSection = document.querySelector('.jdgm-carousel-title');
			if (appsSection && window.scrollY > appsSection.offsetTop + appsSection.offsetHeight) {
				// If below apps section, scroll directly to featured categories
				const featuredSection = document.querySelector('.featured-categories-max-width');
				if (featuredSection) {
					featuredSection.scrollIntoView({ 
						behavior: 'smooth',
						block: 'start'
					});
				}
			} else {
				// Otherwise use the existing functionality
				this.scrollToNearestSectionUp();
			}
		}
	}

	handleScroll() {
		// Check if we're within the "top" threshold (80px)
		if (window.scrollY < this.topThreshold) {
			this.isAtTop = true;
		} else {
			this.isAtTop = false;
		}
		this.updateArrowDirection();
	}

	updateArrowDirection() {
		if (this.isAtTop) {
			this.style.transform = 'rotateZ(180deg)';
		} else {
			this.style.transform = 'rotateZ(0deg)';
		}
	}

	scrollToNearestSectionUp() {
		// Get all section elements
		const sections = Array.from(document.querySelectorAll('section, [data-section-type], [data-section-id]'));
		
		// Get current scroll position
		const scrollPos = window.scrollY;
		
		// Find the nearest section above the current position
		let targetSection = null;
		let closestDistance = Number.MAX_SAFE_INTEGER;
		
		sections.forEach(section => {
			const sectionTop = section.offsetTop;
			const distance = scrollPos - sectionTop;
			
			// Only consider sections above current position (distance > 0)
			if (distance > 0 && distance < closestDistance) {
				closestDistance = distance;
				targetSection = section;
			}
		});
		
		// Scroll to the target section if found
		if (targetSection) {
			targetSection.scrollIntoView({ 
				behavior: 'smooth',
				block: 'start'
			});
		} else {
			// If no section found above, scroll to top
			window.scrollTo({
				top: 0,
				behavior: 'smooth'
			});
			this.isAtTop = true;
			this.updateArrowDirection();
		}
	}
}

// Register the custom element
customElements.define('section-scroller', SectionScroller);

class CollectionSectionScroller extends HTMLElement {
	constructor() {
		super();
		this.upIcon = this.querySelector('.section-scroller-up-icon');
		this.downIcon = this.querySelector('.section-scroller-down-icon');
		this.scrollThreshold = 19; // 100px from top threshold
		this.scrollAmount = window.innerHeight * 0.8; // Scroll by 80% of viewport height
		this.isScrolling = false;
		this.scrollTimeout = null;
		this.lastTapTime = 0;
		this.doubleTapDelay = 300; // 300ms between taps to count as double-tap
	}

	connectedCallback() {
		// Set initial visibility of up button (hidden when at the top)
		this.updateButtonVisibility();

		// Add event listeners
		if (this.upIcon) {
			this.upIcon.addEventListener('click', this.handleUpClick.bind(this));
		}
		
		if (this.downIcon) {
			this.downIcon.addEventListener('click', this.handleDownClick.bind(this));
		}

		// Listen for scroll events to update button visibility
		window.addEventListener('scroll', this.handleScroll.bind(this));
		
		// Add hover effect
		this.addEventListener('mouseenter', this.handleMouseEnter.bind(this));
		this.addEventListener('mouseleave', this.handleMouseLeave.bind(this));
	}

	disconnectedCallback() {
		// Clean up event listeners
		window.removeEventListener('scroll', this.handleScroll.bind(this));
		
		if (this.upIcon) {
			this.upIcon.removeEventListener('click', this.handleUpClick.bind(this));
		}
		
		if (this.downIcon) {
			this.downIcon.removeEventListener('click', this.handleDownClick.bind(this));
		}
		
		this.removeEventListener('mouseenter', this.handleMouseEnter.bind(this));
		this.removeEventListener('mouseleave', this.handleMouseLeave.bind(this));
	}

	handleScroll() {
		// Throttle the scroll event
		if (!this.isScrolling) {
			this.isScrolling = true;
			
			if (this.scrollTimeout) {
				clearTimeout(this.scrollTimeout);
			}
			
			this.scrollTimeout = setTimeout(() => {
				this.updateButtonVisibility();
				this.isScrolling = false;
			}, 100);
		}
	}

	updateButtonVisibility() {
		const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
		const scrollHeight = document.documentElement.scrollHeight;
		const clientHeight = document.documentElement.clientHeight;
		
		// Hide up button when near the top (within threshold)
		if (this.upIcon) {
			this.upIcon.style.display = scrollTop <= this.scrollThreshold ? 'none' : 'block';
			this.upIcon.style.pointerEvents = scrollTop <= this.scrollThreshold ? 'none' : 'auto';
		}
		
		// Hide down button when at the bottom
		if (this.downIcon) {
			const isAtBottom = scrollTop + clientHeight >= scrollHeight - 20;
			this.downIcon.style.display = isAtBottom ? 'none' : 'block';
			this.downIcon.style.pointerEvents = isAtBottom ? 'none' : 'auto';
		}
	}

	handleUpClick(event) {
		const currentTime = new Date().getTime();
		const tapLength = currentTime - this.lastTapTime;
		
		if (tapLength < this.doubleTapDelay && tapLength > 0) {
			// Double tap detected - scroll to viewport top
			window.scrollTo({
				top: 0,
				behavior: 'smooth'
			});
			
			// Reset tap tracking
			this.lastTapTime = 0;
		} else {
			// First tap or taps too far apart - normal scroll up
			this.scrollUp();
			
			// Save the tap time
			this.lastTapTime = currentTime;
		}
	}

	handleDownClick(event) {
		const currentTime = new Date().getTime();
		const tapLength = currentTime - this.lastTapTime;
		
		if (tapLength < this.doubleTapDelay && tapLength > 0) {
			// Double tap detected - scroll to collection main end and center it
			const collectionMain = document.querySelector('.collection__main');
			if (collectionMain) {
				// Calculate position to center the end of collection__main
				const elementRect = collectionMain.getBoundingClientRect();
				const absoluteElementBottom = window.pageYOffset + elementRect.bottom;
				// Adjust to center the bottom of the element
				const middle = absoluteElementBottom - (window.innerHeight / 2);
				
				window.scrollTo({
					top: middle,
					behavior: 'smooth'
				});
			} else {
				// Fallback to bottom if section not found
				window.scrollTo({
					top: document.body.scrollHeight,
					behavior: 'smooth'
				});
			}
			
			// Reset tap tracking
			this.lastTapTime = 0;
		} else {
			// First tap or taps too far apart - normal scroll down
			this.scrollDown();
			
			// Save the tap time
			this.lastTapTime = currentTime;
		}
	}

	scrollUp() {
		const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
		
		// If we're close to the top, scroll all the way to the top
		if (scrollTop <= this.scrollThreshold * 2) {
			window.scrollTo({
				top: 0,
				behavior: 'smooth'
			});
		} else {
			// Otherwise scroll up by the defined amount
			window.scrollBy({
				top: -this.scrollAmount,
				behavior: 'smooth'
			});
		}
	}

	scrollDown() {
		window.scrollBy({
			top: this.scrollAmount,
			behavior: 'smooth'
		});
	}

	handleMouseEnter() {
		this.style.transform = 'scale(1.1)';
	}

	handleMouseLeave() {
		this.style.transform = 'scale(1)';
	}
}

// Register the custom element
customElements.define('collection-section-scroller', CollectionSectionScroller);

// responsive-pictures.js
document.addEventListener('DOMContentLoaded', function() {
  // Handle all responsive pictures on the page
  const responsivePictures = document.querySelectorAll('[data-responsive-picture]');
  
  responsivePictures.forEach(picture => {
    const mainImage = picture.querySelector('[data-main-image]');
    if (!mainImage) return;

    // Check if image is already loaded (from cache)
    if (mainImage.complete) {
      hidePlaceholders(picture);
    } else {
      // Wait for image to load
      mainImage.addEventListener('load', function() {
        hidePlaceholders(picture);
      });
      
      // Fallback in case load event doesn't fire
      setTimeout(() => {
        if (mainImage.complete) {
          hidePlaceholders(picture);
        }
      }, 500);
    }
  });

  // Function to hide placeholders
  function hidePlaceholders(pictureElement) {
    const placeholders = pictureElement.querySelectorAll('.desktop-placeholder, .mobile-placeholder');
    placeholders.forEach(placeholder => {
      placeholder.style.display = 'none';
    });
  }

  // Handle responsive placeholder switching
  function handlePlaceholderVisibility() {
    responsivePictures.forEach(picture => {
      const desktopPlaceholder = picture.querySelector('.desktop-placeholder');
      const mobilePlaceholder = picture.querySelector('.mobile-placeholder');
      
      if (!desktopPlaceholder || !mobilePlaceholder) return;
      
      if (window.matchMedia('(max-width: 767px)').matches) {
        desktopPlaceholder.style.display = 'none';
        mobilePlaceholder.style.display = 'block';
      } else {
        desktopPlaceholder.style.display = 'block';
        mobilePlaceholder.style.display = 'none';
      }
    });
  }

  // Initial check
  handlePlaceholderVisibility();
  
  // Listen for resize events
  window.addEventListener('resize', handlePlaceholderVisibility);
});

//bottom cart

class BottomCart extends HTMLElement {
	constructor() {
		super();
		this.cartUpdateHandler = this.handleCartUpdate.bind(this);
		this.bundleSectionsHandler = this.handleBundleSections.bind(this);
		this.refreshCartHandler = this.handleRefreshCart.bind(this);
	}

	connectedCallback() {
		// Add event listeners
		document.addEventListener('cart:change', this.cartUpdateHandler);
		document.addEventListener('cart:prepare-bundled-sections', this.bundleSectionsHandler);
		document.addEventListener('cart:refresh', this.refreshCartHandler);
	}

	disconnectedCallback() {
		// Remove event listeners
		document.removeEventListener('cart:change', this.cartUpdateHandler);
		document.removeEventListener('cart:prepare-bundled-sections', this.bundleSectionsHandler);
		document.removeEventListener('cart:refresh', this.refreshCartHandler);
	}

	handleBundleSections(event) {
		// Add this section's ID to the sections that should be updated
		const sectionId = this.closest('.shopify-section').id.replace('shopify-section-', '');
		event.detail.sections.push(sectionId);
	}

	handleCartUpdate(event) {
		const cartData = event.detail.cart;
		const sectionId = this.closest('.shopify-section').id.replace('shopify-section-', '');
		
		// Get the updated HTML for this section
		const sectionHtml = cartData.sections[sectionId];
		
		if (sectionHtml) {
			// Parse and update the section content
			const domElement = new DOMParser().parseFromString(sectionHtml, "text/html");
			const newContent = domElement.querySelector('bottom-cart').innerHTML;
			this.innerHTML = newContent;
		}
	}

	async handleRefreshCart() {
		const sectionId = this.closest('.shopify-section').id.replace('shopify-section-', '');
		
		// Fetch the latest cart section HTML
		const response = await fetch(`${window.Shopify.routes.root}?section_id=${sectionId}`);
		const html = await response.text();
		
		// Parse and update the section content
		const domElement = new DOMParser().parseFromString(html, "text/html");
		const newContent = domElement.querySelector('bottom-cart').innerHTML;
		this.innerHTML = newContent;
	}
}

// Register the custom element if it hasn't been registered yet
if (!customElements.get('bottom-cart')) {
	customElements.define('bottom-cart', BottomCart);
}
